import {
    call, put, take, select,
} from 'redux-saga/effects'
import Loader from '../../loader'
import Zoid from '../../zoid'
import { handlePrompt } from './loaderActions'

function* waitFor(selector) {
    if (yield select(selector)) return

    while (true) {
        yield take('*')
        if (yield select(selector)) return
    }
}

export default function* watchInvalidationEvent({
    scope: scopes = [],
    shortCode,
    executePostLoaderActions = false,
}) {
    const {
        publisherId,
        adBlockDetector,
        content,
    } = yield select(Zoid.selectors.getXprops)

    const adBlocking = yield adBlockDetector()

    const requestPayload = {
        ...content,
        adBlocking,
    }

    /* eslint-disable-next-line no-restricted-syntax */
    for (const scope of scopes) {
        yield put(Loader.creators.getLoader({
            scope,
            shortCode,
            publisherId,
            requestPayload,
        }))
    }

    if (executePostLoaderActions) {
        // wait for the loader to finish fetching
        yield call(waitFor, (state) => state.loader.isFetching !== false)

        // then call the prompt
        yield handlePrompt()
    }
}
